export default __webpack_public_path__ + "static/media/image35.db17f1c1.png";